// ProfileForm.tsx
import React from "react";

import { Business } from "0.Mine/3.Interfaces/business";

import { useProfileFormLogic } from "../../Logic/BasicInfo/Profile";
import ProfileFormUI from "../../UI/ProfileFormUI";

interface ProfileFormProps {
  website: string;
  updateBusinessData: (data: Partial<Business>) => void;
  businessData: Partial<Business>;
}

const ProfileForm: React.FC<ProfileFormProps> = ({ website, updateBusinessData, businessData }) => {
  const { description, email, setDescription, setEmail, phone, setPhone } = useProfileFormLogic({
    website,
    updateBusinessData,
    businessData,
  });

  return (
    <ProfileFormUI
      description={description}
      email={email}
      onDescriptionChange={setDescription}
      onEmailChange={setEmail}
      phone={phone}
      onPhoneChange={setPhone}
    />
  );
};

export default React.memo(ProfileForm);
